import { Builder } from '@builder.io/react';
import { ZapCardSection } from '../components/sections/ZapCardSection/ZapCardSection';

const migrateZapCardsSection = () =>
  Builder.registerComponent(ZapCardSection, {
    name: 'ZapCardsSection',
    hideFromInsertMenu: true,
  });

export default migrateZapCardsSection;
